"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M4 20h16V8H4zm4-7h3v-3h2v3h3v2h-3v3h-2v-3H8z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M20 6h-4V4c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2M10 4h4v2h-4zm10 16H4V8h16z"
}, "1"), /*#__PURE__*/_jsx("path", {
  d: "M11 18h2v-3h3v-2h-3v-3h-2v3H8v2h3z"
}, "2")], 'MedicalServicesTwoTone');